import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import DashboardPlugin from "./plugins/dashboard-plugin";
import FirebaseAuth from "./firebase/auth.firebase";
import * as VueGoogleMaps from "vue2-google-maps";
import './assets/scss/main.scss'
import './assets/css/tailwind.css'
import { registerComponents } from 'vuelpers'

Vue.use(VueGoogleMaps, {
	installComponents: true, load: {
		libraries: 'places,drawing,visualization',
		key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY
	}
})

// plugin setup
Vue.use(DashboardPlugin);
Vue.config.productionTip = false
Vue.prototype.$m = require('moment')

registerComponents(
	require.context(
		'./components', true, // is deep
		/Ai[A-Z]\w+\.(vue|js|ts)$/
	), Vue
)

new Vue({
	store,
	router,
	el: "#app",
	created() {
		// Handle on auth state change
		FirebaseAuth.onStateChanged(
			// Logged In
			user => {
				console.log(user)
				store.commit("auth/SET", {
					isLoggedIn: true,
					currentUser: user
				});
				const meta = this.$route.meta
				if (meta && meta.requiresUnAuth) {
					this.$router.push("/");
				}
			},
			// Logged Out
			() => {
				store.dispatch("auth/resetStates");
				router.push("/login");
			}
		);
	},
	render: h => h(App)
});
